import { Email as EmailIcon } from "@mui/icons-material";
import { Box, Button, Paper, Typography } from "@mui/material";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import type { CoachCta } from "../../content/roleFaqsContent";

interface CoachCtaSectionProps {
  cta: CoachCta;
  id?: string;
}

/** Simple **bold** parsing: replace **text** with <strong> */
function parseInlineBold(text: string): React.ReactNode {
  const parts = text.split(/\*\*(.+?)\*\*/g);
  return parts.map((p, i) =>
    i % 2 === 1 ? <strong key={i}>{p}</strong> : p
  );
}

const CoachCtaSection: React.FC<CoachCtaSectionProps> = ({
  cta,
  id = "coach-cta",
}) => {
  return (
    <Box id={id} component="section" sx={{ mb: 6 }}>
      <Paper
        elevation={2}
        sx={{
          p: 4,
          textAlign: "center",
          background:
            "linear-gradient(135deg, rgba(135, 112, 16, 0.1) 0%, rgba(42, 116, 183, 0.1) 100%)",
        }}
      >
        <Typography variant="h4" component="h2" sx={{ mb: 2, fontWeight: "bold", color: "primary.main" }}>
          {cta.title}
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, maxWidth: 560, mx: "auto" }}>
          {cta.codeOfConductPath || cta.mandatedReporterPath ? (
            <>
              Read the{" "}
              {cta.codeOfConductPath ? (
                <RouterLink to={cta.codeOfConductPath} style={{ fontWeight: 600, textDecoration: "underline" }}>
                  Code of conduct
                </RouterLink>
              ) : (
                "Code of conduct"
              )}{" "}
              and{" "}
              {cta.mandatedReporterPath ? (
                <RouterLink to={cta.mandatedReporterPath} style={{ fontWeight: 600, textDecoration: "underline" }}>
                  mandated reporter policy
                </RouterLink>
              ) : (
                "mandated reporter policy"
              )}
              , then{" "}
              <RouterLink to="/contact" style={{ fontWeight: 600, textDecoration: "underline" }}>
                contact us
              </RouterLink>{" "}
              to set up a call.
            </>
          ) : (
            parseInlineBold(cta.body)
          )}
        </Typography>
        <Button
          variant="contained"
          size="large"
          startIcon={<EmailIcon />}
          component={RouterLink}
          to="/contact"
          sx={{ fontWeight: "bold" }}
        >
          Contact Us
        </Button>
      </Paper>
    </Box>
  );
};

export default CoachCtaSection;
